import { render } from "./TheDiemWifiCongCong.vue?vue&type=template&id=f38d150a"
import script from "./TheDiemWifiCongCong.vue?vue&type=script&lang=js"
export * from "./TheDiemWifiCongCong.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__